import React from "react";
import autoBind from "react-autobind";
import { branch,root } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
// import _ from "lodash";
import Activity from "../../Activity";
import * as playerActions from "../../actions/playerActions";
import Loader from "../../components/shared/loader";
import "../../styles/main.scss";
import playerPaths from "../../constants/paths/playerPaths";
import state from "../../state";

class WebPlayerInternal extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);

		let playerCallbacks = {};

		playerCallbacks.onLoad = props.onLoad;
		playerCallbacks.onExit = props.onExit;

		this.props.dispatch(playerActions.initWebPlayer, {
			state: this.props.state,
			drive: this.props.drive,
			activateVoice: this.props.activateVoice,
			activities: this.props.activities,
			activityId: this.props.activityId,
			activityInstanceId: this.props.activityInstanceId,
			activityIdentityId: this.props.activityIdentityId,
			assignmentId:this.props.assignmentId,
			orgPreferences: this.props.orgPreferences,
			inlineShowMode: this.props.inlineShowMode,
			env: this.props.env,
			config: this.props.config,
			expandAllOnLoad: this.props.expandAllOnLoad,
			playerCallbacks
		});
	}

	render() {
		let component;

		if (!this.props.loaded) {
			component = <div className="ambifi-web-player">
				<Loader fullPage show={true} />
			</div>;
		} else {
			component = <Activity />;
		}
		return component;
	}




}

WebPlayerInternal.contextTypes = {
	tree: PropTypes.baobab
};

export default root(state, branch({
	loaded: ["loaded"],
	activity: playerPaths.ACTIVITY
}, WebPlayerInternal));